module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch009"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“LIEUTENANT COMMANDER GEORDI LA FORGE (played by LeVar Burton): He is racially black and birth-defect blind … Totally without optical nerves from birth, his intelligence and spirit captivated a top medical/electronics team. It led to the scientific effort to produce a sensor capable of modifying the electromagnetic spectrum and carrying these readings to the human brain. With his VISOR (Visual Instrument and Sensory Organ Replacement), Geordi’s infra-red vision can ‘see’ the warmth of a recent footprint, use ultra-violet light to ‘see’ through an opaque substance, and much more …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“After having spent a year on the "), _c('em', [_vm._v("Enterprise")]), _vm._v(" as a Bridge Officer (as required by Starfleet regulations), Geordi [was] promoted … and returned to what he was trained to be: the ship’s Engineering Officer….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unlike Riker’s sense of humor, Geordi’s is highly vocal and visible and irreverent. For example, when something dangerous appears on the Main Viewer, Geordi is likely to say something like, ‘Oh, oh, "), _c('em', [_vm._v("big")]), _vm._v(" trouble!’ … He is the starship’s ‘blithe spirit …’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’/directors’ guide ’88–89, second-season revision; and the ’89–90 third-season revision")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“DOCTOR BEVERLY CRUSHER (played by Gates McFadden): “She is one of the most talented and insightful physicians in Starfleet. She and Picard have known each other for many years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doctor Crusher is an intelligent and strong-willed diagnostician. She has a profound sense of medicine, the kind of skill that takes years to develop…. She is first and foremost a brilliant ship’s doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is a beautiful woman and looks considerably younger than her age. Her wit and intelligence have not escaped the Captain’s eye either, and though they have had their differences in the past, they have developed a solid friendship and mutual admiration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Beverly’s husband, Jack Crusher, was killed while serving under Captain Picard on the "), _c('em', [_vm._v("U.S.S. Stargazer")]), _vm._v(". Beverly has long since forgiven Picard for any anger she felt over Jack’s death, and she knows it is not logical to blame him….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Beverly’s son Wesley lived on board the "), _c('em', [_vm._v("Enterprise")]), _vm._v(" with her when she signed on during the first season. Wesley stayed on the "), _c('em', [_vm._v("Enterprise")]), _vm._v(" during the second season while Beverly left the ship to head Starfleet Medical for a year …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’/directors’ guide, special edition 1992–93")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-01.jpg",
      "width": "450px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe33541","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch009.vue
// module id = 99
// module chunks = 0